import React from 'react';
import { TextField, MenuItem, FormControl } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useColorMode from '@/hooks/useColorMode';

const ColorModeSelect = () => {
  const { mode, toggleColorMode } = useColorMode();
  const theme = useTheme();

  const handleChange = (event) => {
    toggleColorMode(event.target.value);
  };

  const modes = [
    { value: 'light', label: 'Light' },
    { value: 'dark', label: 'Dark' },
    { value: 'tokyonight', label: 'Tokyo Night' },
    { value: 'catppuccinmocha', label: 'Catppuccin Mocha' },
    { value: 'heisenberg', label: 'Heisenberg' },
    { value: 'colibri', label: 'Colibri' },
    { value: 'everforest', label: 'Everforest' },
  ];

  return (
    <FormControl fullWidth>
      <TextField
        select
        label="Theme:"
        value={mode}
        onChange={handleChange}
        variant="standard"
        size="small"
        fullWidth
        sx={{
          color: theme.palette.text.primary,
        }}
        slotProps={{
          input: {
            sx: {
              fontFamily: 'Monospace, sans-serif', // Apply font to the selected item
            },
          },
        }}
      >
        {modes.map((themeMode) => (
          <MenuItem
            key={themeMode.value}
            value={themeMode.value}
            sx={{
              fontFamily: 'Monospace, sans-serif', // Apply font to dropdown items
            }}
          >
            {themeMode.label}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
};

export default ColorModeSelect;
